//React Components and Hooks
import Box from "@mui/material/Box";
//Material UI Components and Functions
import { makeStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../components/BreadCrumb";
//Custom Components
import { LeftSidebar as NavFrame } from "layout-blueprints";
import ReportResults from "./ReportResults";
import Tools from "./Tools";
//Context

const useStyles = makeStyles((theme) => ({}));

const IndividualReportPage = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const { reportName } = useParams();

  const asyncEffect = async () => { };
  useEffect(() => {
    asyncEffect();
  }, []);

  return (
    <NavFrame page={reportName}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h4" color="textPrimary">
          {reportName}
        </Typography>
        <BreadCrumb
          crumbs={[{ link: "/reports", label: "Report" }]}
          current={reportName}
        />
        <Tools />
        <ReportResults />
      </Box>
    </NavFrame>
  );
};
export default IndividualReportPage;
